var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor send-waba-template-message" },
    [
      _c(
        "a-spin",
        { staticClass: "spinner", attrs: { spinning: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "editor-row" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v("Sonuç Gelene Kadar Bekle"),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                model: {
                  value: _vm.clone.waitForResponse,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "waitForResponse", $$v)
                  },
                  expression: "clone.waitForResponse",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clone.waitForResponse
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v("Bekleme Süresi (Saniye)"),
                  ]),
                  _vm._v(" "),
                  _c("a-input-number", {
                    attrs: { min: 30, max: 600 },
                    model: {
                      value: _vm.clone.waitTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "waitTime", $$v)
                      },
                      expression: "clone.waitTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "editor-row" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v("Channel"),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "classic-new-select",
                  attrs: { placeholder: "Whatsapp Business Channel" },
                  model: {
                    value: _vm.clone.channelId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "channelId", $$v)
                    },
                    expression: "clone.channelId",
                  },
                },
                _vm._l(_vm.businessChannels, function (channel) {
                  return _c(
                    "a-select-option",
                    { key: channel._id, attrs: { value: channel._id } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(channel.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clone.channelId
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v("\n                Template\n                "),
                    _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            _vm.previewMode = true
                          },
                        },
                      },
                      [_vm._v("visibility")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticClass: "classic-new-select",
                      attrs: {
                        placeholder: "Whatsapp Business Channel",
                        value: _vm.selectedTemplateId,
                      },
                      on: { change: _vm.selectTemplate },
                    },
                    _vm._l(_vm.templates, function (template, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: template.id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(template.elementName) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTemplateId
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v("Whatsapp Phone Number"),
                  ]),
                  _vm._v(" "),
                  _c("TiptapEditor", {
                    attrs: {
                      placeholder: "Whatsapp Phone Number",
                      "show-attributes": true,
                      "max-character-count": 500,
                      "automation-mode": "",
                    },
                    model: {
                      value: _vm.clone.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "phoneNumber", $$v)
                      },
                      expression: "clone.phoneNumber",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTemplateId && _vm.variables.length > 0
            ? _c(
                "div",
                { staticClass: "wpa-variables" },
                _vm._l(_vm.variables, function (variable, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "editor-row" },
                    [
                      _c("div", { staticClass: "editor-row-title" }, [
                        _vm._v("Variable (#" + _vm._s(index + 1) + ")"),
                      ]),
                      _vm._v(" "),
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: "Variable (#" + (index + 1) + ")",
                          "show-attributes": true,
                          "max-character-count": 500,
                          "automation-mode": "",
                        },
                        model: {
                          value: _vm.clone.params[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.params, index, $$v)
                          },
                          expression: "clone.params[index]",
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.clone.template &&
          ["IMAGE", "VIDEO", "DOCUMENT"].includes(
            _vm.clone.template.templateType
          )
            ? _c("div", { staticClass: "image-picker" }, [
                _c(
                  "div",
                  { staticClass: "editor-row" },
                  [
                    _c("div", { staticClass: "editor-row-title" }, [
                      _vm._v("Media Type"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        attrs: { placeholder: "Select Media Type" },
                        model: {
                          value: _vm.mediaType,
                          callback: function ($$v) {
                            _vm.mediaType = $$v
                          },
                          expression: "mediaType",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "static" } }, [
                          _vm._v("Static"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "dynamic" } }, [
                          _vm._v("Dynamic"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.mediaType === "dynamic"
                      ? _c(
                          "div",
                          [
                            _c("TiptapEditor", {
                              attrs: {
                                placeholder: "Dynamic Media URL",
                                "show-attributes": true,
                                "max-character-count": 500,
                                "automation-mode": "",
                              },
                              model: {
                                value: _vm.externalUrl,
                                callback: function ($$v) {
                                  _vm.externalUrl = $$v
                                },
                                expression: "externalUrl",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mediaType === "static"
                      ? _c("div", [
                          _c("div", { staticClass: "media-drag" }, [
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                attrs: {
                                  type: "file",
                                  id: "media-source",
                                  accept: _vm.getAcceptType(),
                                },
                                on: { change: _vm.handleFileUpload },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("image"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v("Click here to upload a picture."),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _c("div", { staticClass: "input-warn" }, [
                              _c("div", [
                                _c("b", [_vm._v("Note:")]),
                                _vm._v(
                                  " Following are the file formats and their respective sizes which are\n                                accepted for upload\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "list-item" }, [
                                _c("li", [
                                  _vm._v("Image: JPEG and PNG (Max size 2 MB)"),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v("Video: MP4 (Max size 20 MB)"),
                                ]),
                                _vm._v(" "),
                                _c("li", [_vm._v("Document: (Max size 2 MB)")]),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.clone.template
        ? _c("WhatsappMessagePreview", {
            attrs: {
              body: _vm.getTemplateParameters(_vm.clone.template).body,
              footer: _vm.getTemplateParameters(_vm.clone.template).footer,
              "header-media-type": _vm.getTemplateParameters(_vm.clone.template)
                .headerType,
              "header-text": _vm.getTemplateParameters(_vm.clone.template)
                .headerText,
              buttons: _vm.getTemplateParameters(_vm.clone.template).buttons,
              headerMediaURL: _vm.getTemplateParameters(_vm.clone.template)
                .headerMediaURL,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }